import { Routes } from '@angular/router';
import { MainLayoutComponent } from './layouts/main-layout.component';
import { restrictedAreaMatchGuard } from './features/restricted-area/restricted-area.match.guard';

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        redirectTo: 'restricted-area',
        pathMatch: 'full',
      },
      {
        path: 'restricted-area',
        canMatch: [restrictedAreaMatchGuard],
        loadChildren: () => import('./features/restricted-area/restricted-area.routes').then((r) => r.routes)
      },
      {
        path: 'auth',
        loadChildren: () => import('./features/auth/auth.routes').then((r) => r.routes)
      }
    ]
  },
];
